import { render, staticRenderFns } from "./ProgressBarMenu.vue?vue&type=template&id=3d2952b4&"
import script from "./ProgressBarMenu.vue?vue&type=script&lang=js&"
export * from "./ProgressBarMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports